module.exports = __webpack_public_path__ + "img/logo.92d86d35.gif";